import React from "react";
import { useTranslation } from "react-i18next";

import TagsFilter from "./TagsFilter";

export default function ChatbotTagsFilters({ loading, tags, value, onChange }) {
  const { t } = useTranslation();

  return (
    <TagsFilter
      loading={loading}
      onChange={onChange}
      tags={tags}
      title={t("opportunity:candidates.chatbotTags.title")}
      tooltip={t("opportunity:candidates.chatbotTags.tooltip")}
      type="chatbot"
      value={value}
    />
  );
}
